export default "__VITE_ASSET__3b63d63f__"